








































import { defineComponent } from "@vue/composition-api";
import useFileSize from "@/hooks/useCheckFileSize";
import useUploadedFilePreview from "@/hooks/useUploadedFilePreview";
import BaseInputFileWithPreview from "@/components/BaseInputFileWithPreview";
import DragDropFiles from "@/components/DragDropFiles";
import UploadedFilesEditModal from "@/components/UploadedFilesEditModal";

export default defineComponent({
  name: "BaseDropZone",
  components: { UploadedFilesEditModal, BaseInputFileWithPreview, DragDropFiles },
  props: {
    multiple: { type: Boolean },
    allowedFileTypes: { type: Array as () => string[], required: true },
    showDropZone: { type: Boolean, required: true },
  },
  setup() {
    const {
      files: droppedFiles,
      updateUploadedFile,
      removeFileFromUploadedList,
      uploadFiles,
    } = useUploadedFilePreview();

    const { checkFilesSize } = useFileSize();

    const onDropFiles = (files: File[]) => {
      droppedFiles.value = checkFilesSize(files);
    };

    return { droppedFiles, onDropFiles, uploadFiles, updateUploadedFile, removeFileFromUploadedList };
  },
});
